// base.js
import { correctedURL } from '../../utilities'
import { Timestamp } from 'firebase/firestore'


export default async function base(state, dispatch, { saveToDB, store }, setlogoToState, customName) {
  const CONCURRENCY_LIMIT = 5 // Maintain exactly 5 parallel uploads

  // 1. Helper: Wraps a single file upload in a Promise
  const uploadSingleFile = (file) => {
    return new Promise((resolve, reject) => {
      // Handle custom renaming logic
      let fileToUpload = file
      if (customName !== null) {
        fileToUpload = new File([file], "logo.png", { type: file.type })
      }

      const task = store(fileToUpload)

      if (!task) {
        resolve()
        return
      }

      task.on(
        'state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          dispatch({
            type: 'status',
            name: task.snapshot.ref.name,
            value: { progress, size: snapshot.totalBytes },
          })
        },
        (error) => {
          console.error("Upload failed for file:", file.name, error)
          reject(error)
        },
        async () => {
          const { bucket, fullPath, name } = task.snapshot.ref
          const { totalBytes: size } = task.snapshot

          // Remove status bar and increment counter immediately
          dispatch({ type: 'removeStatus', name })
          dispatch({ type: 'incrementUploaded' }) 

          const payload = {
            bucket,
            fullPath,
            url: correctedURL(fullPath),
            name,
            size,
            created: Timestamp.now(),
          }

          try {
            await saveToDB(payload)
            if (setlogoToState) setlogoToState(payload)
          } catch (err) {
            console.error("Error saving to DB:", err)
          }
          
          resolve() // Resolve this file's promise so the worker can pick the next one
        }
      )
    })
  }

  // 2. The Queue Logic
  // Clone the files array so we can shift items off it without affecting state
  const fileQueue = [...state.files]

  // A "Worker" keeps grabbing the next file from the queue until it's empty
  const runWorker = async () => {
    while (fileQueue.length > 0) {
      const file = fileQueue.shift() // Get the next file from the top of the pile
      if (file) {
        await uploadSingleFile(file) // Wait ONLY for this specific file to finish
      }
      // Loop immediately repeats to grab the next file
    }
  }

  // 3. Start the Engine
  // Create 5 workers that run simultaneously
  const workers = Array(CONCURRENCY_LIMIT).fill(null).map(() => runWorker())

  // The main function waits until ALL workers have nothing left to do
  await Promise.all(workers)
}